
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)","fill":"#6C6C6C"}},[_c('path',{attrs:{"d":"M10 16a.667.667 0 01-.667-.667A.334.334 0 009 15c-.92 0-1.667-.748-1.667-1.667v-.666a.667.667 0 111.333 0v.666c0 .184.15.334.334.334.919 0 1.666.748 1.666 1.666A.667.667 0 0110 16z"}}),_c('path',{attrs:{"d":"M10.834 13.333H5.167a2.503 2.503 0 01-2.5-2.5V6.5a.5.5 0 01.5-.5h9.667a.5.5 0 01.5.5v4.333c0 1.379-1.122 2.5-2.5 2.5zM10.833 0H5.167C4.527 0 4 .527 4 1.167V5h8V1.167C12 .527 11.473 0 10.833 0zM6.667 3.5c0 .273-.227.5-.5.5a.504.504 0 01-.5-.5V1.833c0-.273.226-.5.5-.5.273 0 .5.227.5.5V3.5zm1.833 0c0 .273-.227.5-.5.5a.504.504 0 01-.5-.5V1.833c0-.273.227-.5.5-.5s.5.227.5.5V3.5zm1.833 0c0 .273-.226.5-.5.5a.504.504 0 01-.5-.5V1.833c0-.273.227-.5.5-.5.274 0 .5.227.5.5V3.5z"}})])])
          )
        }
      }
    